import Vue from 'vue'
import VueI18n from 'vue-i18n'
import ren from './_report/en/lang'
import rtc from './_report/tc/lang'

Vue.use(VueI18n)

const locale = localStorage.getItem('locale') || 'tc'

const i18n = new VueI18n({
  locale,
  messages: { ren, rtc }
})

export default i18n



// WEBPACK FOOTER //
// ./src/constants/lang/i18n.js